import { logEvent, setAnalyticsCollectionEnabled } from 'firebase/analytics';
/**
 * Firebase Analytics telemetry service for tracking user behavior and usage metrics
 */
export class TelemetryService {
    constructor(analytics, logger, config) {
        this.analytics = analytics;
        this.logger = logger;
        this.config = config;
        this.userId = null;
        if (this.config.isDev) {
            // Enable analytics collection for debug mode
            setAnalyticsCollectionEnabled(this.analytics, true);
            this.logger.info('Firebase Analytics debug mode enabled - events will be visible in Firebase console debug view');
        }
        this.logger.info('Firebase Analytics telemetry service initialized');
    }
    /**
     * Set the user context for all subsequent events
     */
    setUserId(userId) {
        this.userId = userId;
        this.logger.debug(`Telemetry user context set: ${userId}`);
    }
    /**
     * Clear the user context
     */
    clearUserId() {
        this.userId = null;
        this.logger.debug('Telemetry user context cleared');
    }
    /**
     * Track a generic telemetry event
     */
    trackEvent(eventName, event) {
        try {
            const eventProperties = {
                ...event,
                isDev: this.config.isDev,
                userId: this.userId,
                timestamp: Date.now(),
                appVersion: '1.0.0'
            };
            // In debug mode, also log to console for immediate feedback
            if (this.config.isDev) {
                this.logger.info(`🔥 TELEMETRY [${eventName}]:`, eventProperties);
                console.group(`🔥 Firebase Analytics: ${eventName}`);
                console.table(eventProperties);
                console.groupEnd();
            }
            logEvent(this.analytics, eventName, eventProperties);
            this.logger.debug(`Telemetry event tracked: ${eventName}`, eventProperties);
        }
        catch (error) {
            this.logger.error(`Failed to track telemetry event ${eventName}:`, error);
        }
    }
    /**
     * Track job creation
     */
    trackJobCreated(event) {
        this.trackEvent('job_created', event);
    }
    /**
     * Track candidate creation
     */
    trackCandidateCreated(event) {
        this.trackEvent('candidate_created', event);
    }
    /**
     * Track candidate scoring
     */
    trackCandidateScored(event) {
        this.trackEvent('candidate_scored', event);
    }
    /**
     * Track candidate score changes
     */
    trackCandidateScoreChanged(event) {
        this.trackEvent('candidate_score_changed', event);
    }
    /**
     * Track user login
     */
    trackUserLogin(event) {
        this.trackEvent('user_login', event);
    }
    /**
     * Track user logout
     */
    trackUserLogout(event) {
        this.trackEvent('user_logout', event);
    }
    /**
     * Track pricing page view
     */
    trackPricingPageView(event) {
        this.trackEvent('pricing_page_view', event);
    }
    /**
     * Track application errors
     */
    trackError(event) {
        this.trackEvent('error', event);
    }
    /**
     * Track initial data load performance
     */
    trackInitialDataLoaded(event) {
        this.trackEvent('initial_data_loaded', event);
    }
}
